exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table .custom-control.custom-checkbox[data-v-f3b4a4c4] {\n  margin: 0;\n}\n", ""]);

// exports
